/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPACCOUNTHOLDERTYPE = {
    CompanyRegistrationNumber: 'CompanyRegistrationNumber',
    IdentityNumber: 'IdentityNumber',
    PassportNumber: 'PassportNumber',
    TrustNumber: 'TrustNumber'
} as const;
export type IAPACCOUNTHOLDERTYPE = typeof IAPACCOUNTHOLDERTYPE[keyof typeof IAPACCOUNTHOLDERTYPE];


export function IAPACCOUNTHOLDERTYPEFromJSON(json: any): IAPACCOUNTHOLDERTYPE {
    return IAPACCOUNTHOLDERTYPEFromJSONTyped(json, false);
}

export function IAPACCOUNTHOLDERTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPACCOUNTHOLDERTYPE {
    return json as IAPACCOUNTHOLDERTYPE;
}

export function IAPACCOUNTHOLDERTYPEToJSON(value?: IAPACCOUNTHOLDERTYPE | null): any {
    return value as any;
}

